import { render, staticRenderFns } from "./OrderRecordQ.vue?vue&type=template&id=08ae9c74&"
import script from "./OrderRecordQ.vue?vue&type=script&lang=js&"
export * from "./OrderRecordQ.vue?vue&type=script&lang=js&"
import style0 from "./OrderRecordQ.vue?vue&type=style&index=0&id=08ae9c74&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports